<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Név"
    show-overflow-tooltip
    fixed
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
